import { render, staticRenderFns } from "./OrganisasiPengusahaKota.vue?vue&type=template&id=52c1404f"
import script from "./OrganisasiPengusahaKota.vue?vue&type=script&lang=js"
export * from "./OrganisasiPengusahaKota.vue?vue&type=script&lang=js"
import style0 from "./OrganisasiPengusahaKota.vue?vue&type=style&index=0&id=52c1404f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports